import React from 'react';
import PropTypes from 'prop-types';
export var Component = function Component(_ref) {
  var bottom = _ref.bottom,
      children = _ref.children,
      left = _ref.left,
      right = _ref.right,
      top = _ref.top,
      zIndex = _ref.zIndex;
  return React.createElement("div", {
    style: {
      bottom: bottom,
      display: 'inline-block',
      left: left,
      position: 'fixed',
      right: right,
      top: top,
      zIndex: zIndex
    }
  }, children);
};
Component.displayName = 'FixedContainer';
Component.defaultProps = {
  bottom: '',
  left: '',
  right: '',
  top: '',
  zIndex: 1
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  bottom: PropTypes.string,
  children: PropTypes.node.isRequired,
  left: PropTypes.string,
  right: PropTypes.string,
  top: PropTypes.string,
  zIndex: PropTypes.number
} : {};